import {flattenObject} from './ObjectUtils';

export function checkValidation(validation) {
    const flattened = flattenObject(validation);

    return Object.values(flattened).every(field => !!field);
}

export function isValidRunTime(time) {
    const timeRegex = new RegExp('^[0-9]+:[0-9]+[,.][0-9]{1,9}$');
    return time === 'DNF' || timeRegex.test(time);
}